/** Items Flavor */
export enum EItemFlavor {
    brand = "brand",
    type = "type",
    boughtWith = "boughtWith",
  }